export const steps = {
  RATING: 1,
  COMMENT: 2,
  SUMMARY: 3,
};

export const rating = {
  FAVORITE: 4,
  VERY_GOOD: 3,
  ALMOST: 2,
  NOT_SUITABLE: 1,
  NON_COMPLIANT: 0,
};
